<script>
    /*
    	SaveResourceButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    const SVG_IMAGE_PATH   = '/img/save_resource.svg';
    const SVG_CONNECT_PATH   = '/svg-icons/button-icons/molecular-1.svg';

    export let onClick;

    onMount(() => {
    })

</script>

<style>

    .save-resource-button button {
        padding: 10px 15px 10px 15px;
        font-size: 15px;
        color: var(--tcui-primary);
        background-color: #D3DDF9;
        border-radius: 16px;
        border: none;
    }

    .save-resource-button button:hover {
        color: white;
        background-color: var(--tcui-secondary);
    }

    .save-resource-button .button-content {
        display: flex;
        align-items: center;
    }

    /*
    .save-resource-button .button-content img {
        width: 14px;
        height: 14px;
        margin-left: 10px;
    }
    */

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="save-resource-button">
    <button on:click={onClick}>
        <div class="button-content">
            Save Resource
<!--            <img style={'height: 20px; padding-right: .25em'} src={SVG_CONNECT_PATH} alt={'Connect'} draggable="false" >-->
<!--            Connect-->
        </div>
    </button>
</div>
